// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ea34f747","72":"0b90205f","87":"827094db","155":"9a2f3bff","187":"c8550b78","190":"2d6979a2","202":"e403e1c9","479":"8a1743fb","488":"3000fc9f","490":"d572e441","599":"940b7e3f","800":"8e27ec0e","881":"779af5a4"}[chunkId] + ".chunk.js";
};